module.exports = __webpack_public_path__ + "static/media/temp_w_domu_ok_4.a6490354.svg";